import type { ActiveSubscriptionsDto, SubscriptionPlanDto } from "../services/BillingService";

const SECONDS_PER_DAY = 60 * 60 * 24;

export const calculateRemainingDays = (cycleEnd: number) => {
  const now = Date.now() / 1000;
  if (cycleEnd < now) {
    return 0;
  }

  return Math.ceil((cycleEnd - now) / SECONDS_PER_DAY);
};

export const findBaseSubscription = (subscriptions: ActiveSubscriptionsDto): SubscriptionPlanDto | undefined =>
  subscriptions.find(({ type }) => type === "BASE");
